<template>
  <tr @click="toggleIndividualContact()">
    <td>{{ rowNumber }}</td>
    <td>{{ formatDate(contact.repliedDate) }}</td>
    <td>{{ formatDate(contact.receiver.joinedDate) }}</td>
    <td>{{ contact.receiver.last_name }} {{ contact.receiver.name }}</td>
    <td>{{ contact.jobDetail }}</td>
    <td>
      <span class="user-response">{{ contact.user_response }}</span>
    </td>
    <td>
      <span class="status-badge" :style="{ backgroundColor: getStatusColor(contact.receiver.status), color: getStatusTextColor(contact.receiver.status) }">{{ contact.receiver.status }}</span>
    </td>
    <td style="text-align: center !important;">
      <div
        class="circle resume-circle"
        :class="{ 'filled-circle': contact.receiver.resume }"
      ></div>
    </td>
    <td style="text-align: center !important;">
      <div
        class="circle cv-circle"
        :class="{ 'filled-circle': contact.receiver.cv }"
      ></div>
    </td>
    <!-- <td style="text-align: center !important; min-width: 60px !important;">
      
    </td> -->
    <td style="text-align: center !important;">
      <input
        type="checkbox"
        name="hide"
        @click.stop
        v-model="contact.isHidden"
        @change="hideItem()"
        style="width: 20px;height:20px"
        :value="true"
      />
    </td>
    <!-- REMOVED: 送受信履歴 column
    <td style="text-align: center !important;">
      <span class="contact-history-link" @click.stop="openContactHistory()">
        <img
          src="@/assets/images/newTab.png"
          alt="送受信履歴"
          class="contact-history-icon"
        />
        送受信<br />履歴
      </span>
    </td>
    <td></td>
    -->
    <IndividualContactModal
      v-if="showIndividualContact"
      :applicantIndex="index"
      :applicant_id="contact.receiver._id"
      contactListType="received"
    />
  </tr>
</template>

<script>
import moment from 'moment';
import StatusBox from './StatusBox.vue';
import IndividualContactModal from '../IndividualContactModal.vue';
export default {
  name: 'ReceivedContactRow',
  props: ['receivedContact', 'index', 'rowNumber', 'applicantIndex'],
  components: { StatusBox, IndividualContactModal },
  data() {
    return {
      contact: this.receivedContact,
      showIndividualContact: false,
    };
  },
  methods: {
    toggleIndividualContact() {
      this.showIndividualContact = !this.showIndividualContact;
    },
    formatDate(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    getStatusColor(status) {
      const colorMap = {
        '未判定': '#DD2A29',
        'スカウト対象': '#006C6B',
        'スカウト対象外': '#AB8271',
        '確認中': '#FFEA00',
        'スカウト済': '#71B566',
        '返信有': '#E08282',
        '応募有': '#14B8A6',
        'システム取込み済': '#787878',
        '中長期対応': '#8F5AA5',
        'その他': '#535252',
      };
      return colorMap[status] || '#6C757D';
    },
    getStatusTextColor(status) {
      // Yellow status needs dark text, others use white
      return status === '確認中' || status === '確認依頼中' ? '#000' : '#fff';
    },
    hideItem() {
      this.$emit('hideItem', this.contact);
    },
    openIndividualContact(applicant) {
      let routeUrl = this.$router.resolve({
        path: `/applicant/${applicant._id}/contact`,
      });
      // Open in a new tab
      window.open(routeUrl.href, '_blank');
    },
    openContactHistory() {
      let routeUrl = this.$router.resolve({
        path: `/applicant/${this.contact.receiver._id}/contact`,
      });
      // Open in a new tab
      window.open(routeUrl.href, '_blank');
    },
  },
};
</script>

<style scoped>
.user-response {
  display: inline-block;
  width: 130px;
  height: 32px;
  border-radius: 3px;
  background: transparent;
  color: #3c3c3c;
  padding: 5px;
  text-align: center;
  max-height: 32px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.status-badge {
  display: inline-block;
  padding: 10px 24px;
  border-radius: 4px;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  min-width: 150px;
  max-height: 40px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.gray-tab {
  background-color: #787878;
}

.circle {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #fff;
  border: 2px solid #e7e9ec;
  display: inline-block;
  margin: 0 auto;
}

.filled-circle {
  background-color: #006c6b;
  border-color: #006c6b;
}

td {
  text-align: center !important;
  font-size: 15px !important;
  color: #3c3c3c !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

tr {
  cursor: pointer;
}

.contact-history-link {
  color: #000;
  cursor: pointer;
  font-size: 14px;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.contact-history-link:hover {
  color: #333;
  text-decoration: underline;
}

.contact-history-icon {
  font-size: 61px;
  color: #000;
  width: 61px;
  height: 61px;
}
</style>
